import {locationContainer, rawRenderingLib} from '@wallaby-ui/core';

import {eventAnnotationRenderer} from './event_annotation_renderer';
import baseTimelineAnnotationsStatefullFormatterParams from 'src/js/lib/raw_rendering/base_timeline_annotations_statefull_formatter_params';

/**
 * Returns raw DOM version of TimelineAnnotationsStatefullFormatter component.
 * @param params
 * @param services
 * @returns {Element}
 */
export default function timelineAnnotationsStatefullFormatter(
  params,
  services = {}
) {
  const {ownQueryParameters, value} =
    baseTimelineAnnotationsStatefullFormatterParams(params, services);
  // TODO: link to /encounter/{encounterId}/document/{rowData.documentVersionId}
  //  try to pass and get encounterId from react context

  let divElem;
  if (value) {
    divElem = document.createElement('div');

    if (value.annotations) {
      value.annotations.forEach((annotation) => {
        const eventAnnotationElem = eventAnnotationRenderer(
          {
            annotation,
            caseId: value.caseId,
            queryParameters:
              ownQueryParameters[locationContainer.GLOBAL_PARAMETERS_PATH],
          },
          services
        );
        rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
          divElem,
          eventAnnotationElem
        );
      });
    }
  } else {
    divElem = '';
  }

  return divElem;
}
